import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const Day = (props) => {
  const {
    dayNumber,
    myEvents,
    events
  } = props;
  const thisDayMyEvents = [];
  const thisDaySubscribes = [];
  const today = props.today.split('T')[0];

  const date = () => {
    const month = props.month + 1 >= 10 ? props.month + 1 : `0${props.month + 1}`;
    const day = props.dayNumber >= 10 ? props.dayNumber : `0${props.dayNumber}`;
    return moment(`${props.year}-${month}-${day}`).format('YYYY-MM-DD');
  };

  const isToday = () => {
    const dateBlock = date();
    if (today === dateBlock)
      return 'today';
    return ''
  };

  const setMyEvents = () => {
    for (let i = 0; i < myEvents.length; i++) {
      const eventAt = moment(myEvents[i]).format('YYYY-MM-DD');
      if (eventAt === date()) {
        thisDayMyEvents.push(myEvents[i])
      }
    }
    if (thisDayMyEvents.length > 0)
      return 'myEvents';
    return ''
  };

  const setMySubscribers = () => {
    for (let i = 0; i < events.length; i++) {
      const eventAt = moment(events[i].event_at).format('YYYY-MM-DD');
      if (eventAt === date()) {
        thisDaySubscribes.push(events[i])
      }
    }
    if (thisDaySubscribes.length > 0)
      return 'subscribeEvents';
    return ''
  };

  const returnThisDate = () => {
    if (typeof props.returnThisDate === 'function'){
      props.returnThisDate(date())
    }
  };

  return (
    <li className={`calendar__day-item ${props.className} ${isToday()} ${setMyEvents()} ${setMySubscribers()}`}>
      <button onClick={returnThisDate} >{dayNumber}</button>
    </li>
  )
};

Day.propTypes = {
  dayNumber: PropTypes.number,
  className: PropTypes.string,
  year: PropTypes.number,
  month: PropTypes.number,
  today: PropTypes.string,
  returnThisDate: PropTypes.func,

  myEvents: PropTypes.array,
  events: PropTypes.array,
};

Day.defaultProps = {
  className: '',
  myEvents: [],
  events: [],
};

export default Day;



// WEBPACK FOOTER //
// ./src/app/components/Calendar/Day.js